import { CloseSquare, Refresh } from "iconsax-react";
import { useState } from "react";
import { getToken } from "../../../utils/token";
import NormalInputField from "../../inputs/NormalInputField";
import PrimaryAddButton from "../../buttons/PrimaryAddButton";
import instance from "../../../axios/instance";
import { toast } from "react-toastify";
import { useRevalidator } from "react-router-dom";

export default function EditSpa({ onClose, isOpen, spa }) {
  const token = getToken();
  const [isLoading, setIsLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [code, setCode] = useState(spa.code || "");
  const [name, setName] = useState(spa.name || "");
  const revalidator = useRevalidator();

  const isButtonNotActive = !name || !code;

  const handleCreateFacility = (e) => {
    e.preventDefault();
    setIsLoading(true);
    instance
      .put(
        "/doctor/med-spas/update",
        {
          name,
          code,
          spaId: spa.id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("SPA info updated");
        revalidator.revalidate();
        onClose();
      })
      .catch((error) => {
        toast.error(
          error.response ? error?.response?.data?.message : error.message
        );
        setIsLoading(false);
      });
  };

  const generateSpaCode = () => {
    setGenerating(true);
    instance
      .post(
        "/doctor/med-spas/generate-code",
        {
          name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setCode(response.data.code);
        setGenerating(false);
      })
      .catch((error) => {
        toast.error(
          error.response ? error?.response?.data?.message : error.message
        );
        setGenerating(false);
      });
  };

  return (
    <>
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } fixed min-w-[400px] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-40 bg-white overflow-y-scroll scrollbar-hide rounded-md`}
      >
        <div className="sticky left-0 right-0 top-0">
          <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between">
            <div>
              <div className="text-[18px] font-bold select-none">Update Referral</div>
            </div>
            <button onClick={onClose}>
              <CloseSquare variant="Bold" />
            </button>
          </div>
        </div>

        <form
          onSubmit={handleCreateFacility}
          className="px-5 py-3 text-[14px] mt-4"
        >
          <div className="space-y-4">
            <NormalInputField
              title="Name"
              isRequired={true}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <NormalInputField
              title="Code"
              isRequired={true}
              type="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          {name && (
            <span
              className="text-xs text-primary underline flex gap-x-1.5 items-center mt-1.5 cursor-pointer"
              onClick={generateSpaCode}
            >
              <Refresh size={13} />{" "}
              {generating ? "Generating..." : "Generate code"}
            </span>
          )}
          <div className="mt-9">
            <PrimaryAddButton
              title="Update Referral"
              isLoading={isLoading}
              disabled={isButtonNotActive || isLoading}
              color="white"
              type="submit"
            />
          </div>
        </form>
      </div>
      {isOpen && (
        <div
          className="fixed z-20 inset-0 bg-[rgba(0,0,0,.2)]"
          onClick={onClose}
        />
      )}
    </>
  );
}
